import { render, staticRenderFns } from "./FormControlTypeRelationshipOneToMany.vue?vue&type=template&id=8d4e666a&scoped=true"
import script from "./FormControlTypeRelationshipOneToMany.vue?vue&type=script&lang=js"
export * from "./FormControlTypeRelationshipOneToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4e666a",
  null
  
)

export default component.exports